import * as firebase from 'firebase';
import FirebaseTools from './FirebaseTools';
import { CollectionActions } from '../stores/collection.store';
import store from './../stores';
import NumistaAPI from './NumistaAPI';


class FirebaseCollection {
  constructor() {
    this.firebase = FirebaseTools.firebase;
    this.db = firebase.firestore(this.firebase.app);
    this.collection = this.db.collection('collections');
  }

  async getCoins() {
    store.dispatch(CollectionActions.startGetCoins);
    try {
      const coins = await this.collection.get().then((coins) => coins.docs.map((coin) => coin.data()));
      store.dispatch(CollectionActions.endSuccessGetCoins, coins);
    } catch (e) {
      store.dispatch(CollectionActions.endFailGetCoins);
    }
  }

  async addCoin(coin) {
    const docId = (+new Date()).toString();
    const meta = { createdAt: new Date(), modifiedAt: new Date(), docId , amount: 1 };
    const data = Object.assign({}, coin, meta);
    store.dispatch(CollectionActions.startAddCoin);
    try {
      await this.collection.doc(docId).set(data);
      const coinCreated = await this.collection.doc(docId).get().then(doc => doc.data());

      store.dispatch(CollectionActions.endSuccessAddCoin, coinCreated);
      return coinCreated;
    } catch (e) {
      store.dispatch(CollectionActions.endFailAddCoin);
      throw e;
    }
  }

  async addCoinFromList(id) {
    const coin = await NumistaAPI.getDetails(id);
    const cleanedCoin = this.parseCoin(coin);
    await this.addCoin(cleanedCoin);
  }

  async increaseAmountOfCoin(coin) {
    const meta = { modifiedAt: new Date() };
    const data = Object.assign({}, coin, meta);
    data.amount += 1;
    return this.updateCoin(data);
  }

  async decreaseAmountOfCoin(coin) {
    if (coin.amount <= 1) {
      return this.removeCoin(coin) ;
    } else {
      const meta = { modifiedAt: new Date() };
      const data = Object.assign({}, coin, meta);
      data.amount -= 1;
      return this.updateCoin(data);
    }
  }

  async updateCoin(coin) {
    const { docId } = coin;
    store.dispatch(CollectionActions.startUpdateCoin);
    try {
      await this.collection.doc(docId).set(coin);
      const updatedCoin = await this.collection.doc(docId).get().then(doc => doc.data());
      store.dispatch(CollectionActions.endSuccessUpdateCoin, updatedCoin);
    } catch (e) {
      store.dispatch(CollectionActions.endFailUpdateCoin);
      throw e;
    }
  }

  async removeCoin({ docId }) {
    store.dispatch(CollectionActions.startRemoveCoin);
    try {
      await this.collection.doc(docId).delete();

    } catch(e) {
      store.dispatch(CollectionActions.endFailRemoveCoin);
      throw e;
    }
  }

  async clearCollection() {
    const coinIds = store.state.collection.coins.map((coin) => coin.docId);
    let promises = [];
    for (let i = 0; i < coinIds.length; i++) {
      promises.push(this.collection.doc(coinIds[i]).delete());
    }
    store.dispatch(CollectionActions.startRemoveCoin);
    try {
      await Promise.all(promises);
      store.dispatch(CollectionActions.endSuccessRemoveAllCoins);
    } catch(e) {
      store.dispatch(CollectionActions.endFailRemoveCoin);
      throw e;
    }
  }

  clean() {
    store.dispatch(CollectionActions.cleanCollection);
  }

  parseCoin(coin) {
    return {
      id: coin.id,
      country: coin.country.name,
      images: {
        copyright: coin.images.copyright,
        obverse: coin.images.obverse.fullsize,
        reverse: coin.images.reverse.fullsize,
      },
      metal: coin.metal || 'undefined',
      rarity: coin.rarity_index || 'undefined',
      shape: coin.shape || 'undefined',
      name: coin.title,
      value: coin.value || 'undefined',
      weight: coin.weight || 0,
      yearsRange: coin.years_range || 'undefined',
    };
  }
}

export default new FirebaseCollection();
